import styled from "styled-components";
import React from "react";

export const Container = styled.p`
  font-size: .85rem;
  margin-bottom: 0;
  transition: .3s;

  &:hover {
    opacity: .8;
  }
`;


const ForwarderLink = ({...otherProps}) => {
    return (
        <Container {...otherProps}/>
    );
};

export default ForwarderLink;
